import request from '@/config'

import { CtTempSearchDto, CtTempDelDto, CtTempCreateDto, CtTempEditDto } from './templates.dto';

/* 合同模板：列表(List) */
export const GetCtTemplateListApi = (search: CtTempSearchDto): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/getpagedlist', data: search })

}

/* 合同模板：明细(Detail) */
export const GetCtTemplateInfoApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/getdetail', data: { id: rowId } })

}

/* 合同模板：删除(Delete) */
export const GetCtTemplateDelApi = (delInput: CtTempDelDto): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/deletion', data: delInput })

}

/* 合同模板：创建(Create) */
export const CreateTemplateApi = (delInput: CtTempCreateDto): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/creation', data: delInput })

}

/* 合同模板：修改(Editor) */
export const EditTemplateApi = (delInput: CtTempEditDto): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/modify', data: delInput })

}

/* 设置模板启用/停用状态 */
export const TempStatusChangeApi = (rowId: string): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/enabledordisabled', data: { id: rowId } })

}

/* 获取模板选择列表(有效数据) */
export const GetTempSelectApi = (searchKey?: string): Promise<IResponse> => {

    return request.post({ url: '/api/cttemplate/getenabledlist', data: { search_key: searchKey } })

}



